<template>
  <div class="channel">
    <div class="search fixed_horizo_center">
      <div class="flex-center margin-bot">
        <van-search class="flex1" v-model="filter.activityName" clearable placeholder="搜索海报" @input="updateSearch" @focus="focusSearch" @clear="clearPlaybill" />
        <span :span="4" class="search-text" @click="cancelSearch" v-show="isCancel">取消</span>
      </div>

      <van-tabs class="tab_customer" v-model="filter.stuId" @change="onClickTab" v-show="!isCancel">
        <van-tab v-for="item in subjectList" :name="item.id" :title="item.name" :key="item.id"></van-tab>
      </van-tabs>
    </div>
    <div class="posterList" ref="posterList">
      <van-list v-model="loading" :finished="finished" loading-text="正在加载中..." finished-text="暂无更多内容了" @load="load_more" v-show="!isSearch" :immediate-check="false">
        <div v-for="(item, index) in list" :key="index + 'i'" class="item_customer">
          <div class="item">
            <div class="flex-start">
              <van-image class="avatar_user" fit="cover" :src="item.activityCover" />
              <div class="flex1 flex-center">
                <div class="title flex1">
                  <h4>{{ item.activityName }}</h4>
                  <p>{{ item.activityStart + "-" + item.activityEnd }}</p>
                  <div class="live_flex">
                    <span>{{ compare(item.activityEnd) ? "录播" : "直播" }}</span>
                    <div class="contact-btn" @click="goDetail(item)">生成海报</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </van-list>
      <div class="searchData" v-show="isSearch">
        <div v-for="(item, index) in searchList" :key="index + 'i'" class="item_customer">
          <div class="item">
            <div class="flex-start">
              <van-image class="avatar_user" fit="cover" :src="item.activityCover" />
              <div class="flex1 flex-center">
                <div class="title flex1">
                  <h4>{{ item.activityName }}</h4>
                  <p>{{ item.activityStart + "-" + item.activityEnd }}</p>
                  <div class="live_flex">
                    <span>{{ compare(item.activityEnd) ? "录播" : "直播" }}</span>
                    <div class="contact-btn" @click="goDetail(item)">生成海报</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <p v-show="isShowData">暂无数据</p>
    </div>
  </div>
  <!-- <emptyPage :isLimit="isLimit"></emptyPage> -->
</template>

<script>
import { Toast } from "vant";
import { playBillList, playBillQuery, subjectQuery } from "@/server/api.js";
import { addressBar, wefunstatistics } from "@/utils/public";

export default {
  name: "playbill",
  data() {
    return {
      list: [], //客户列表
      loading: false,
      finished: false,
      isShow: true,
      isShowData: false,
      isCancel: false, //是否显示取消按钮
      userId: "",
      filter: {
        pageNum: 1,
        pageSize: 20,
        activityId: "", //活动id
        activityName: "", // 活动名称
        status: "", //状态 ： 1 发布 2 未发布
        stuId: "", //学科id
        stuName: "", //学科名称
        teacherName: "", //老师名称
      },
      subjectList: [],
      isSearch: false,
      searchList: [],
    };
  },
  watch: {
    // "$store.state.tokenFlag": function (newval) {
    //   if (newval) {
    //     this.subjectQueryList();
    //     wefunstatistics("3", window.location.href.split('#')[0]);
    //     this.getPlaybillList();
    //     this.userId = localStorage.getItem("userid");
    //   }
    // },
  },
  mounted() {
    let windowurl = window.location.href.split("#")[0] || "http://tm-qw.1000phone.net/poster";
    if (localStorage.getItem("token")) {
      this.subjectQueryList();
      wefunstatistics("3", window.location.href.split("#")[0]);
      this.getPlaybillList();
      this.userId = localStorage.getItem("userid");
    } else {
      addressBar("token", windowurl);
    }
  },
  methods: {
    //海报列表
    async getPlaybillList() {
      this.loading = true;
      const res = await playBillList(this.filter);
      this.loading = false;
      if (res.code !== "200") return Toast.fail(res.msg);
      this.list = this.list.concat(res.data.list);

      if (res.data.list.length == 0 || res.data.list.length < this.pageSize) {
        //数据全部加载完成
        this.finished = true;
      } else {
        this.finished = false;
      }
    },
    //搜索海报列表
    async getPlaybillQuery() {
      this.loading = true;
      let { activityId, activityName } = this.filter;
      const res = await playBillQuery({ activityName, activityId });
      this.loading = false;
      if (res.code !== "200") return Toast.fail(res.msg);
      this.searchList = res.data;
    },

    //学科列表
    async subjectQueryList() {
      this.loading = true;
      const res = await subjectQuery("");
      this.loading = false;
      if (res.code !== "200") return Toast.fail(res.msg);
      this.subjectList = [{ name: "全部", id: "" }];
      this.subjectList.push(...res.data);
    },

    scrollTop() {
      this.$nextTick(() => {
        window.scrollTo(0, 0);
      });
    },

    //加载更多
    load_more() {
      this.filter.pageNum++;
      this.getPlaybillList();
    },
    posterFun() {
      this.list = [];
      this.scrollTop();
      this.filter.pageNum = 1;
      this.getPlaybillList();
    },
    subjectFun() {
      this.searchList = [];
      this.getPlaybillQuery();
    },
    //实施触发
    updateSearch(val) {
      console.log(val);
      if (val) {
        this.filter.activityName = val;
        this.filter.stuId = "";
        this.isShowData = false;
        this.subjectFun();
      } else {
        this.filter.activityName = val;
        this.isShowData = true;
        this.searchList = [];
      }
    },
    //cancel search
    cancelSearch() {
      this.isSearch = false;
      this.isCancel = false;
      this.isShowData = false;
      this.filter.stuId = "";
      this.filter.pageNum = 1;
      this.filter.activityName = "";
      this.$refs.posterList.classList.remove("search_poster");
      this.posterFun();
    },
    //focus search
    focusSearch() {
      if (this.filter.activityName) {
        this.isSearch = true;
      } else {
        this.isSearch = true;
      }
      this.$refs.posterList.classList.add("search_poster");
      this.isCancel = true;
    },
    //tab切换
    onClickTab(data) {
      this.filter.stuId = data;
      this.filter.pageNum = 1;
      this.posterFun();
    },
    //清除搜索
    clearPlaybill() {
      this.filter.activityName = "";
      this.list = [];
      this.filter.pageNum = 1;
    },
    compare(val) {
      let getmide = new Date((val + ":00").replace(/-/g, "/")).getTime();
      let isMore = Date.now() > getmide;
      return isMore;
    },
    //海报详情页
    goDetail(item) {
      this.$router.push({
        path: "/posterDetail",
        query: {
          id: item.id,
          desc: item.des,
          userId: this.userId,
        },
      });
    },
  },
};
</script>

<style lang="less" scoped>
.channel {
  width: 100%;
  height: 100%;
  background: #f6f6f6;
  .search {
    padding: 20px 30px 10px;
    background: #fff;
    position: fixed;
    width: 100%;
    top: 0;
    left: 0;
    z-index: 100;

    .margin-bot {
      margin-bottom: 16px;
    }
    .tab_customer {
      /deep/.van-tabs__wrap {
        height: 60px;
        .van-tabs__nav {
          padding-left: 0;
        }
      }
      /deep/.van-tab {
        padding: 0 24px 0 0;
        font-size: 28px;
      }
      /deep/.van-tab--active {
        color: #267df0;
        font-weight: 500;
      }
      /deep/.van-tabs__line {
        background-color: transparent;
      }
    }
  }

  .van-search {
    padding: 0;

    /deep/ .van-icon-search {
      font-size: 28px;
    }

    /deep/ .van-field__control {
      font-size: 28px;
    }
  }

  .van-search__content {
    height: 80px;
    padding-left: 30px;
    border-radius: 40px;
    background-color: #f3f3f3;
  }

  .van-search .van-cell {
    align-items: center;
  }

  .van-field__left-icon {
    height: 80px;
  }

  .search-text {
    font-size: 28px;
    padding-left: 20px;
    cursor: pointer;
    color: #267df0;
  }

  .posterList {
    padding: 210px 0 24px 0;
    &.search_poster {
      padding-top: 110px;
    }
    p {
      font-size: 28px;
      color: #666666;
      text-align: center;
      margin-top: 50px;
    }
    .item_customer {
      position: relative;
      box-sizing: border-box;
      overflow: hidden;
      padding: 23px 28px;
      background: #fff;
      border-radius: 14px;

      .customer-tag-list {
        overflow: hidden;
        height: auto;
        transition: all 0.4s linear;
        padding-left: 8px;
      }

      .overFlow {
        height: 110px;
      }

      .van-image {
        width: 160px;
        height: 160px;
        border-radius: 8px;
        overflow: hidden;
        flex-shrink: 0;
        & + div {
          width: 0;
        }
      }

      .title {
        font-size: 24px;
        padding-left: 20px;

        h4 {
          font-size: 28px;
          margin-top: -3px;
          line-height: 1.4;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
        }
        p {
          color: #999999;
          margin: 4px 0;
          font-size: 20px;
          text-align: left;
          &:last-child {
            margin-bottom: 0;
          }
        }
        .live_flex {
          // width: 514px;
          width: calc(100% - 237px);
          position: absolute;
          bottom: 23px;
          span {
            background-color: rgba(39, 127, 255, 0.2);
            padding: 4px 19px;
            color: #277fff;
            border-radius: 5px;
            font-size: 20px;
            display: inline-block;
            position: relative;
            top: 10px;
          }
          .contact-btn {
            padding: 8px 18px;
            font-size: 22px;
            border-radius: 5px;
            color: #ffffff;
            background-color: #277fff;
            text-align: center;
            float: right;
          }
        }
      }
    }
  }
  .van-multi-ellipsis--l2 {
    -webkit-line-clamp: 1;
  }

  .border-top {
    height: 500px;
    padding-bottom: 42px;
    overflow-y: auto;
    border-top: solid 1px #f4f4f4;
    margin-top: 6px;
  }
}
</style>
